// actionTypes.js
export const ActionTypes = {
  FETCH_DASHBOARD_REQUEST: "FETCH_DASHBOARD_REQUEST",
  FETCH_DASHBOARD_SUCCESS: "FETCH_DASHBOARD_SUCCESS",
  FETCH_DASHBOARD_FAILURE: "FETCH_DASHBOARD_FAILURE",
  FETCH_USER_INFO_DASHBOARD_REQUEST: "FETCH_USER_INFO_DASHBOARD_REQUEST",
  FETCH_USER_INFO_DASHBOARD_SUCCESS: "FETCH_USER_INFO_DASHBOARD_SUCCESS",
  FETCH_USER_INFO_DASHBOARD_FAILURE: "FETCH_USER_INFO_DASHBOARD_FAILURE",
}
